import config from '../../config/config';

export const BANK_LOAD = 'BANK/BANK_LOAD';
export const BANK_SUCCESS = 'BANK/BANK_SUCCESS';
export const BANK_FAILURE = 'BANK/BANK_FAILURE';

export function getBank() {
    return {
        failureActionTypeOrCreator: getBankFailureActionCreator,
        fetchParams: {
            url: `${config.userManagementApiUrl}/account/bankinfo`
        },
        loadActionTypeOrCreator: BANK_LOAD,
        successActionTypeOrCreator: getBankSuccessActionCreator
    };
}

export function getBankSuccessActionCreator(bank) {
    return {
        bank,
        type: BANK_SUCCESS
    };
}

export function getBankFailureActionCreator(error) {
    return {
        error,
        type: BANK_FAILURE
    };
}
